export const ECourierStatusType = {
  Offline: 0,

  Online: 1,
}

export type ECourierStatusType = (typeof ECourierStatusType)[keyof typeof ECourierStatusType]
